/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-19 17:51:46
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-21 17:09:45
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/Query1/Filter/MultiSelections/index.tsx
 */
import React from 'react';
import css from './css.module.less';

import { CheckboxGroup, Input } from 'src/components/Antd';
import DropDown from '../DropDown';
import { useAfterDidMountEffect } from 'src/tools/customHooks';
import { getLabel } from '../tools';
import { Empty } from 'antd';
import { isEqual } from 'lodash';

const MultiSelections = (props) => {
  const {
    keyWord,
    value: selected = [],
    options: o = [],
    onConfirm,
    //onDropDownChange,
    dropDownVisible,
    searchable,
    sortedByFirstLetter = true,
  } = props;
  //console.log('sortedByFirstLetter', sortedByFirstLetter);
  const options = sortedByFirstLetter
    ? o.sort(function (a, b) {
        return (a.label + '').localeCompare(b.label + '');
      })
    : o;

  const [_selected, _setSelected] = React.useState(selected || []);
  const [search, setSearch] = React.useState('');
  const _options = React.useMemo(() => {
    if (!search) {
      return options;
    } else {
      const o = options.filter((i) => {
        const _search = search.toLocaleLowerCase();
        const _label = i.label.toLocaleLowerCase();
        return _label.indexOf(_search) > -1;
      });
      return o;
    }
  }, [search, options]);
  const _checks = _options.map((i) => {
    return { ...i, className: css.check };
  });
  useAfterDidMountEffect(() => {
    if (!dropDownVisible) {
      if (isEqual(_selected.sort(), selected.sort())) {
      } else {
        handleOnConfirm(_selected);
      }
      setSearch('');
    }
    if (dropDownVisible) {
      if (selected !== _selected) {
        _setSelected(selected || []);
      }
    }
  }, [dropDownVisible]);

  const handleOnConfirm = (key = []) => {
    if (onConfirm) {
      onConfirm({
        [keyWord]: getLabel(key, options),
      });
    }
  };

  return (
    <div className={css.container}>
      {searchable && (
        <Input
          size='small'
          className={css.input}
          onChange={setSearch}
          value={search}
        />
      )}

      {(_checks || []).length > 0 ? (
        <CheckboxGroup
          className={css.checkboxGroup}
          checks={_checks}
          value={_selected}
          onChange={_setSelected}
        />
      ) : (
        <Empty />
      )}
    </div>
  );
};

export default DropDown(MultiSelections, {});
